import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Avatar, Button, LinearProgress } from '@mui/material';
import { Link, useParams } from "react-router-dom";
import ApprovePopup from '../ApprovePopup';
import { useDispatch, useSelector } from 'react-redux';
import { setApprovePopUpOPen,setUploadPopupOpen, setViewNotePopoup } from '../../Store/mainSlice';
import { useEffect } from 'react';
import UploadPopup from '../UploadPopup';
import { UploadSimple } from '@phosphor-icons/react';
import ViewNotePopup from '../ViewNotePopup';


const Grid = (props) => {
  const { id } = useParams()
  const [hoveredRowIndex, setHoveredRowIndex] = useState(null);
  const dispatch = useDispatch();
  const isApprovePopupOpen = useSelector((state) => state.mainSlice.approvePopupOpen);
  const isUploadPopupOpen = useSelector((state)=> state.mainSlice.isUploadPopupOpen);
  const isViewNotePopupOpen = useSelector((state)=>state.mainSlice.isViewNotePopupOpen);
  const [stdId, setStdId] = useState('')
  const [noteId,setNoteId] = useState('')
  const [CNICNo, setCNICNo] = useState('')
  const [applicationId, setApplicationId] = useState('')


  const linkTemplate = (data, col) => {
    if (col.to) {
      return (
        <Link to={col?.appendID ? col.to + data["_id"] : col.to}>
          {data[col.field]}
        </Link>
      );
    }
    // else if (data.stdId) {
    //   return (
    //     <Link to={props.baseURL + data["_id"] + "/" + data["stdId"]} style={{ textDecoration: 'none', color: 'inherit' }}>
    //       {data[col.field]}
    //     </Link>
    //   );
    // }
    //For routing against CNICNo
    else if (data.CNICNo) {
      return (
        <Link to={props.baseURL + data["CNICNo"]} style={{ textDecoration: 'none', color: 'inherit' }}>
          {data[col.field]}
        </Link>
      );
    }
    return (
      <Link to={props.baseURL + data["_id"]} style={{ textDecoration: 'none', color: 'inherit' }}>
        {data[col.field]}
      </Link>
    );
  };

  const approvePopupClick = async (CNICNo,applicationId) => {
    console.log("approvePopupClick func",applicationId);
    
    console.log("approve clicked")
    dispatch(setApprovePopUpOPen(true))
    setCNICNo(CNICNo)
    setApplicationId(applicationId)
    console.log("popup open", open);
  }

  const closeApprovepopup = () => {
    dispatch(setApprovePopUpOPen(false));
    console.log("isApprovePopupOpen", isApprovePopupOpen);
  }

  const uploadPopupClick = async () => {
    // setIsUploadPopupOpen(true)
    dispatch(setUploadPopupOpen(true))
    console.log("popup open", open);
    setStdId(id)
  }

  const closeUploadpopup =async()=>{
    dispatch(setUploadPopupOpen(false))
  }

  const viewNotePopupClick = async(noteId)=>{
    dispatch(setViewNotePopoup(true))
    setNoteId(noteId)
  }

  const closeViewNotePopup = async()=>{
    dispatch(setViewNotePopoup(false))
  }


  const buttonTempelate = (data, field) => {
    {
      if (field === 'view') {
        return (
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#208146",
              color: 'white',
              width: '89px',
              height: "4vh",
              fontSize: '12px',
              borderRadius: '8px',
              "&:hover": {
                backgroundColor: "#208146",
              },
            }}

            onClick={()=>approvePopupClick(data["CNICNo"],data["_id"])}
          >
            View
          </Button>
        )
      }
      else if(field === 'view/edit'){
        return (
          <Button
          variant="contained"
          sx={{
            backgroundColor: "#208146",
            color: 'white',
            width: '104px',
            height: "4vh",
            fontSize: '12px',
            borderRadius: '8px',
            "&:hover": {
              backgroundColor: "#208146",
            },
          }}
          onClick={()=>viewNotePopupClick(data["_id"])}
          >
            View / Edit
          </Button>
        
        )
      }
      else {
        return (
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#208146",
              color: 'white',
              width: '104px',
              height: "4vh",
              fontSize: '12px',
              borderRadius: '8px',
              "&:hover": {
                backgroundColor: "#208146",
              },
            }}
            onClick={() => uploadPopupClick()}
          >
            <UploadSimple size={17} />
            Upload
          </Button>
        )
      }
    }

  }


  useEffect(() => {
    // alert('id',id)
    console.log("id", id);
  }, [])



  return (
    <>
      {isApprovePopupOpen && <ApprovePopup open={true} onClose={closeApprovepopup} id={applicationId} CNICNo={CNICNo} stdId={props.gridData.stdId ? props.gridData.stdId : props.stdId}/>}
      {isUploadPopupOpen && <UploadPopup open={true} onClose={closeUploadpopup} id={stdId} />}
      {isViewNotePopupOpen && <ViewNotePopup open={true} onClose={closeViewNotePopup} noteId={noteId}/>}
      <TableContainer
        component={Paper}
        style={{
          borderTopLeftRadius: '4px',
          borderTopRightRadius: '4px',
          marginTop: '15px',
          // marginLeft: '10px',
          // marginRight: '10px',
          marginBottom: '20px',
          //   boxShadow: 'none'
        }}
      >
        <Table stickyHeader aria-label="sticky table" >
          <TableHead style={{}}>
            <TableRow>
              {props.gridHeader.length > 0 &&
                props.gridHeader.map((headerObj) => (
                  <TableCell key={headerObj.field} style={{ backgroundColor: '#DADADA' }}>{headerObj.headerName}</TableCell>
                ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {props.gridData.map((row, index) => (
              <TableRow
                key={index}
                onMouseEnter={() => setHoveredRowIndex(index)}
                onMouseLeave={() => setHoveredRowIndex(null)}
                style={{ backgroundColor: 'white', height: '5vh' }}
              >
                {props.gridHeader.map((headerObj) => (
                  <TableCell
                    key={headerObj.field}
                    style={{
                      paddingTop: '8px',
                      paddingBottom: '8px',
                      borderBottom: '6px solid rgba(224, 224, 224, 1)',
                      color: row.isApproved
                        ? (row.isChargedBack
                          ? "red"
                          : "#008000"
                        )
                        : 'black'
                    }}
                  >
                    {
                      headerObj.field === 'checkbox' ? (
                        <input
                          type="checkbox"
                          checked={props.selectedAgentIds.includes(row.id)}
                          onChange={() => props.handleCheckboxChange(row.id)}
                        />
                      ) : headerObj.field === 'img' ? (
                        <Avatar src={row[headerObj.field]} shape="circle" size="large" />
                      ) : headerObj.isLink ? (
                        linkTemplate(row, headerObj)
                      )
                        : headerObj.isButton ? (
                          buttonTempelate(row, headerObj.field)
                        )
                          : headerObj.isProgressBar ? (
                            <LinearProgressWithLabel value={row[headerObj.field]} />
                          )
                            : (
                              row[headerObj.field]
                            )
                    }
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default Grid;